export const styles = {
  wrapper: { display: 'block', position: 'relative' },
  slide: (marginTops, index, height, isExtraHeight) => {
    const countedHeight = isExtraHeight && index === 0 ? 220 : height;
    const blockTop = index > 0 ? (isExtraHeight ? 208 : 268) : 120;

    return {
      height: countedHeight,
      mt: marginTops[index],
      position: 'sticky',
      top: blockTop,
      transform: `translateY(${
        (index > 0 ? index - 1 : index) * (isExtraHeight ? 75 : 45)
      }px)`,
    };
  },
};
